import { createAsyncThunk } from '@reduxjs/toolkit';
import customerApi from '~/apis/customer';
import {
  CREATE_CUSTOMER,
  EDIT_CUSTOMER,
  GET_ORGANIZATION,
  CREATE_NOTE,
  GET_CUSTOMER,
  GET_CUSTOMERS,
  GET_CUSTOMER_FILES,
  UPDATE_NOTE,
  GET_CUSTOMER_CONTACT,
  GET_FOLDERS,
  GET_SELECTION_CUSTOMER,
  GET_CONTACTS,
  GET_CRM_BOARD,
  CREATE_CUSTOMER_FILES,
  SEND_MAIL,
  GET_CUSTOMER_FILE,
} from '~/utils/constants/actionType';
import {
  ICustomer,
  IEditCustomer,
  IParamsGetCustomer,
  IParamsGetCustomerSelection,
  IParamsOrganization,
  IResponseGetCRMBoard,
  IResponseGetListCustomer,
  IResponseGetOrganization,
} from '~/utils/interface/customer';
import { IResponseGetFiles } from '~/utils/interface/customer';
import { IJobFolderCreate, IResponseGetFolders } from '~/utils/interface/folder';
import { IJobFileCreate, IResponseGetNote } from '~/utils/interface/job';
import { ISendMail } from '~/utils/interface/mail';
import { IEditNote } from '~/utils/interface/note';

export const handleCreateCustomer = createAsyncThunk<ICustomer, IEditCustomer>(
  CREATE_CUSTOMER,
  async (data: IEditCustomer, { rejectWithValue }) => {
    try {
      const res = await customerApi.create(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleSendMail = createAsyncThunk<ISendMail, ISendMail>(
  SEND_MAIL,
  async (data: ISendMail, { rejectWithValue }) => {
    try {
      const res = await customerApi.sendMail(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCustomers = createAsyncThunk<IResponseGetListCustomer, IParamsGetCustomer>(
  GET_CUSTOMERS,
  async (params: IParamsGetCustomer = {}, { rejectWithValue }) => {
    try {
      const res = await customerApi.getListCustomer(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCRMBoard = createAsyncThunk<IResponseGetCRMBoard, IParamsGetCustomer>(
  GET_CRM_BOARD,
  async (params: IParamsGetCustomer = {}, { rejectWithValue }) => {
    try {
      const res = await customerApi.getBoard(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetContacts = createAsyncThunk<IResponseGetListCustomer, IParamsGetCustomer>(
  GET_CONTACTS,
  async (params: IParamsGetCustomer = {}, { rejectWithValue }) => {
    try {
      const res = await customerApi.getListCustomer(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetSelectionCustomers = createAsyncThunk<IResponseGetOrganization, IParamsGetCustomerSelection>(
  GET_SELECTION_CUSTOMER,
  async (params: IParamsGetCustomerSelection = {}, { rejectWithValue }) => {
    try {
      const res = await customerApi.getSelectCustomer(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetDetail = createAsyncThunk<ICustomer, string>(
  GET_CUSTOMER,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await customerApi.getDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleGetContactDetail = createAsyncThunk<ICustomer, string>(
  GET_CUSTOMER_CONTACT,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await customerApi.getContactDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleEditCustomer = createAsyncThunk<ICustomer, { id: string | undefined; params: IEditCustomer }>(
  EDIT_CUSTOMER,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await customerApi.update(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetOrganization = createAsyncThunk<IResponseGetOrganization, { params: IParamsOrganization }>(
  GET_ORGANIZATION,
  async ({ params }, { rejectWithValue }) => {
    try {
      const res = await customerApi.getOrganization(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCustomerFiles = createAsyncThunk<IResponseGetFiles, { id: string | undefined }>(
  GET_CUSTOMER_FILES,
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await customerApi.getFiles(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetFiles = createAsyncThunk<IResponseGetFiles, { id: string | undefined; data: IJobFileCreate }>(
  GET_CUSTOMER_FILE,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await customerApi.getCustomerFiles(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateCustomerUploadFiles = createAsyncThunk<null, { id: string | undefined; data: FormData }>(
  CREATE_CUSTOMER_FILES,
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await customerApi.createUploadFiles(id, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateNote = createAsyncThunk<null, IEditNote>(
  CREATE_NOTE,
  async (data: IEditNote, { rejectWithValue }) => {
    try {
      const res = await customerApi.createNotes(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateNotes = createAsyncThunk<IResponseGetNote, { id: number | string; params: IEditNote }>(
  UPDATE_NOTE,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await customerApi.updateNotes(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCustomerFolders = createAsyncThunk<
  IResponseGetFolders,
  { id: string | undefined; data: IJobFolderCreate }
>(GET_FOLDERS, async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await customerApi.getFolders(id, data);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
